import {
  ESV_PRIVATE_BUCKET,
  AUTOMATION_PRIVATE_BUCKET,
} from "./Constant";

export const s3ESVPrivate = {
  region: "us-east-2",
  bucket: ESV_PRIVATE_BUCKET,
};

export const s3AutomationPrivate = {
  region: "us-east-2",
  bucket: AUTOMATION_PRIVATE_BUCKET,
};
